function SentinelSiteVisitTable($interval, $filter, $rootScope, $location, sentinelService, filterService) {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            tableTitle: "=",
            visitCallback: "=",
            visits: "=",
            currentView: "=?"
        },
		template: require('./site-visit-table.html'),

        link: function (scope) {
            scope.displayOptions = filterService.getTableDisplayOptions(scope.tableTitle);
            scope.masterDisplayOptions = filterService.getMasterDisplayOptions();
            scope.displayVisits = [];
            scope.aggVisits = [];
            scope.fiveMinsAgo = new Date();
            scope.timerUpdate = $interval(updateNewCommentThreshold, 1000);
            scope.showBadgeIds = false;
            scope.userHasWrite = ($rootScope.selectedLog.role !== 'READ');
            scope.requiredFields = {};
            scope.selectedFacility = "";
            scope.displayOptions.sortField = scope.currentView === "check-in" ? 'timeRegistered' : 'checkInTime';
            scope.loadingVisits = true;
            scope.printed = false;

            function initializeVisits(newValue) {
                if (!(newValue instanceof Array)) {
                    return;
                }

                var tempVisits = [].concat(newValue);
                scope.aggVisits = aggByFacility(tempVisits);

                tempVisits = filterService.sortVisits(scope.displayOptions.sortField, scope.displayOptions.sortDirection, tempVisits);
                scope.displayVisits = sentinelService.generateUiData(tempVisits);
            }

            function checkIfBadgesRequired() {
                sentinelService.getFacilitiesList($rootScope.selectedLog.id).then(function (facilities) {
                    for (var i = 0; i < facilities.length; i++) {
                        sentinelService.getBadgesRequired($rootScope.selectedLog.id, facilities[i]).then(function (badgesRequired) {
                            if (badgesRequired !== 'disabled') return scope.showBadgeIds = true;
                        });
                    }
                });
            }

            function finalize() {
                $interval.cancel(scope.timerUpdate);
                scope.timerUpdate = null;
            }

            function updateNewCommentThreshold() {
                scope.fiveMinsAgo.setSeconds(scope.fiveMinsAgo.getSeconds() + 1);
            }

            function exportToExcel(fileName, originalData) {
                // Process data so that it matches table view and is appropriate for excel
                var data = [];
                originalData.forEach(function(oldVis) {
                    var newVis = {};
                    newVis['Visitor'] = oldVis.formattedName;
                    newVis['Company'] = oldVis.company;
                    if (scope.isVis('visiting')) newVis['Visiting'] = oldVis.visiting;
                    if (scope.isVis('reason')) newVis['Reason'] = oldVis.reason;
                    if (scope.isVis('telephone')) newVis['Telephone'] = oldVis.telephone;
                    if (scope.isVis('isCitizen')) newVis['Citizen'] = $filter('checkedToYes')(oldVis.isCitizen);
                    if (scope.isVis('nda')) newVis['NDA'] = $filter('checkedToYes')(oldVis.nda);
                    newVis['Facility Name'] = oldVis.facilityName;
                    if (scope.currentView !== 'check-in' && scope.showBadgeIds) newVis['Badge Code'] = oldVis.badgeCodeManual;
                    if (scope.currentView !== 'check-in') newVis['Door In'] = oldVis.doorIn;
                    if (scope.currentView !== 'check-in') newVis['Escort In'] = oldVis.escortIn;
                    if (scope.currentView === 'visits') newVis['Door Out'] = oldVis.doorOut;
                    if (scope.currentView === 'visits') newVis['Escort Out'] = oldVis.escortOut;
                    if (scope.currentView === 'check-in') newVis['Registration Time'] = $filter('date')(oldVis.timeRegistered, 'MM/dd/yyyy HH:mm:ss');
                    if (oldVis.checkInTime) newVis['Check-in Time'] = $filter('date')(oldVis.checkInTime, 'MM/dd/yyyy HH:mm:ss');
                    if (scope.currentView !== 'check-in' && oldVis.checkOutTime)
                        newVis['Check-out Time'] = $filter('date')(oldVis.checkOutTime, 'MM/dd/yyyy HH:mm:ss');
                    data.push(newVis);
                });

                // Header row
                var header = '<tr>' + Object.keys(data[0]).map(function(key) {
                    return '<td>' + key + '</td>';
                }).join('') + '</tr>';

                // Data rows
                var dataRows = "";
                data.forEach(function(dataObj) {
                    var objStr = Object.keys(dataObj).map(function(key) {
                        return dataObj[key] != null ? "<td>" + dataObj[key] + "</td>" : "<td></td>";
                    }).join('');
                   dataRows += '<tr>' + objStr + '</tr>';
                });

                var table = ('<table>' + header + dataRows + '</table>').trim();

                var title = "title";
                var xlsTemplate = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">' +
                    ' <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"/>' +
                    ' <head><!--[if gte mso 9]><xml> <x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name> ' + title + '</x:Name><x:WorksheetOptions>' +
                    ' <x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml>' +
                    ' <![endif]--></head> <body> ' + table + '</body></html>';

                var xlsBlob = new Blob([xlsTemplate], {
                    type: 'application/vnd.ms-excel;base64,'
                });
                var xlsLink = window.URL.createObjectURL(xlsBlob);
                var anchor = document.createElement('a');
                document.body.appendChild(anchor);
                anchor.download = fileName;
                anchor.href = xlsLink;
                anchor.click();
            }

            function aggByFacility(visits) {
                var facilitiesDict = {};
                var facilitiesArr = [];
                visits.forEach(function(visit) {
                   if (facilitiesDict[visit.facilityName] === undefined) facilitiesDict[visit.facilityName] = 1;
                   else facilitiesDict[visit.facilityName] += 1;
                });
                for (var key in facilitiesDict) {
                    facilitiesArr.push({name:key, visits:facilitiesDict[key]});
                }
                return facilitiesArr.sort(function(a, b) {
                    return a.name > b.name ? 1 : -1;
                });
            }

            scope.checkInVisitor = function (visit) {
                $rootScope.$broadcast('sentinel-show-check-in-modal', {visitorToCheckIn: visit});
            };

            scope.checkOutVisitor = function (visit) {
                $rootScope.$broadcast('sentinel-show-check-out-modal', {visitorToCheckOut: visit});
            };

            scope.undoCheckinVisitor = function (visit) {
                sentinelService.undoCheckinVisitor(visit);
            };

            scope.undoCheckoutVisitor = function (visit) {
                sentinelService.undoCheckoutVisitor(visit);
            };

            scope.editVisitor = function(visit){
                $rootScope.$broadcast('sentinel-show-edit-modal', {visitorToEdit: visit});
            };

            scope.removeVisitor = function(visit) {
                sentinelService.removeVisitor(visit);
            };

            scope.addComment = function(visit) {
                $rootScope.$broadcast('sentinel-show-comment-modal', {visitorToAddCommentTo: visit});
            };

            scope.getRequiredFields = function() {
                sentinelService.getRequiredFields($rootScope.selectedLog.id, scope.selectedFacility).then(function (rf) {
                    scope.requiredFields = rf;
                });
            };

            scope.isVis = function (name) {
                return (scope.requiredFields && scope.requiredFields[name] === "optional" || scope.requiredFields[name] === "required");
            };

            scope.$on('selected-facility-changed', function(e, selectedFacility) {
                scope.selectedFacility = selectedFacility.selectedFacility;
                scope.getRequiredFields();
            });

            scope.$on('sentinel-update-start', function() {
                scope.loadingVisits = true;
            });

            scope.$on('sentinel-update-successful', function() {
                scope.loadingVisits = false;
            });

            scope.$on('sentinel-update-failed', function() {
                scope.loadingVisits = false;
            });

            scope.$on('exportExcel', function() {
                exportToExcel("test.xls", scope.displayVisits)
            });

            window.addEventListener("beforeprint", function(e) {
               scope.printed = true;
            });

            window.addEventListener("afterprint", function(e) {
                scope.printed = false;
            });

            (function () {
                checkIfBadgesRequired();
                scope.fiveMinsAgo.setMinutes(new Date().getMinutes() - 5);
                scope.$watch('visits', initializeVisits);
                scope.$watch('masterDisplayOptions', function () {
                    initializeVisits(scope.visits);
                }, true);
                scope.$watch('displayOptions', function () {
                    initializeVisits(scope.visits);
                }, true);
                scope.$on('$destroy', finalize);
            })();

            scope.selectedFacility = sentinelService.getSelectedFacility();
            scope.getRequiredFields();

            var headerSize = scope.currentView === 'visits' ? 340 : 270;
            var marginBtm = 15;
            var offset = 0;
            var heightCorrection = headerSize + marginBtm - offset;
            var visitorRowHeight = 131;
            var totalHeight = window.innerHeight - heightCorrection;

            $interval(function() {
                if (scope.printed) {
                    scope.tableStyle = {};
                    return;
                }
                var heightString = totalHeight > visitorRowHeight * scope.visits.length ? 'auto' : totalHeight + 'px';
                scope.tableStyle = {
                    "max-height": heightString
                };
            }, 100);
        }
    }
}

angular.module('sentinel').directive('sentinelSiteVisitTable', ['$interval', '$filter', '$rootScope', '$location', 'sentinelService', 'sentinelUiFilterService', SentinelSiteVisitTable]);